import { AttentionBox, Dropdown } from 'monday-ui-react-core';
import React, { useEffect, useRef, useState } from 'react'
import Tree from 'react-d3-tree'
import MondayLoader from '../cmps/MondayLoader';
import { mondayService } from '../services/mondayService';
import { utilsService } from '../services/utils.Service';

export default function ObjectivesTree({ monday, relations, boardId, boards }) {
    const [treeData, setTreeData] = useState()
    const [treeHead, setTreeHead] = useState()
    const [treeHeadPos, setTreeHeadPos] = useState({ x: 0, y: 0 })
    const [boardFoldersMap, setBoardFoldersMap] = useState(null)
    const treeRef = useRef()

    useEffect(() => {
        if (treeRef.current) {
            setTreeHeadPos({ x: treeRef.current.clientWidth / 2, y: treeRef.current.clientHeight / 4 })
        }
    }, [treeRef.current])

    useEffect(() => {
        if (relations && boardId) {
            setTreeHead(() => {
                const currRelation = relations?.find(relation => +relation.mainBoard.board.value === +boardId)
                return currRelation ? currRelation.mainBoard.board : null
            })
        }
    }, [relations, boardId])

    useEffect(() => {
        if (relations && boardId && boards) {
            const boardId = treeHead?.value
            const res = buildTree(relations, boardId)
            setTreeData(res)

            loadFolders()
        }
    }, [relations, boardId, boards, treeHead])

    function buildTree(nodes, headId) {
        // Find the root node with the given headId
        const rootNode = nodes.find(node => +node.mainBoard.board.value === +headId);

        if (!rootNode) {
            const node = boards.find(board => +board.value === +headId)
            return { name: node?.label, id: node?.value };
        }

        // Map the children recursively
        const tree = {
            name: rootNode.mainBoard.board.label,
            id: rootNode.mainBoard.board.value,
            children: rootNode.subBoards.map(child => buildTree(nodes, child.subBoard)),
        };

        return tree;
    }

    const getMainBoards = () => {
        return relations ? relations.map(relation => relation.mainBoard.board) : []
    }

    const loadFolders = async () => {
        try {
            // remove duplicate boards
            let boardIds = relations.reduce((acc, relation) => {
                const subBoardIds = relation.subBoards.map(board => +board.subBoard)
                return [...acc, ...subBoardIds, +relation.mainBoard.board.value]
            }, [])

            // find board folder
            const query = `query {
                            boards(ids: [${[...new Set(boardIds)]}]){
                                id
                                board_folder_id 
                            }
                        }`
            const res = await monday.api(query)
            if (!res.data) return setBoardFoldersMap({})
            const folderIds = res.data.boards.map(board => board.board_folder_id)
            const boardFoldersMap = res.data.boards.reduce((acc, board) => {
                acc[board.id] = { folder: { folderId: board.board_folder_id } }
                return acc
            }, {})

            // get folder data
            const resFolderData = await mondayService.getFoldersData([...(new Set(folderIds))])
            Object.keys(boardFoldersMap).forEach((boardId) => {
                const folderId = boardFoldersMap[boardId].folder.folderId
                boardFoldersMap[boardId].folder = resFolderData[folderId]
            })

            setBoardFoldersMap(boardFoldersMap)

        } catch (error) {
            console.log(" loadFolders ~ error:", error)
        }

    }

    const NodeElement = (props) => {

        const { nodeDatum = {}, toggleNode, foreignObjectProps = {}, addChildren, hierarchyPointNode, onNodeClick, onNodeMouseOut, onNodeMouseOver } = props
        const nodeName = nodeDatum?.name
        const nodeId = nodeDatum?.id
        if (!nodeId) return <g></g>

        const nodeFolder = boardFoldersMap?.[nodeId]?.folder
        const backgroundColor = nodeFolder?.color
        const color = backgroundColor ? utilsService.textColorBasedOnBackground(backgroundColor) : ''
        // const nodeId = nodeDatum?.id

        return <g>
            <foreignObject  {...foreignObjectProps}       >
                <div className='node' onClick={onNodeClick} style={{ borderColor: backgroundColor }}>
                    <div className={nodeFolder?.color ? "node-header" : "node-header colorless-folder"} style={{ backgroundColor: nodeFolder?.color || '', color: color || '' }}>
                        <b className='ellipsis'>{nodeFolder?.name}</b>
                    </div>
                    <div className="node-body">
                        <p className='ellipsis'>{nodeName}</p>
                    </div>
                </div>
            </foreignObject>
        </g>
    }

    if (!treeData || !boardFoldersMap) return <MondayLoader />
    return <>
        <div className='tree-container ovbjectives-tree' ref={treeRef} >
            <div className="select-div">
                <Dropdown
                    className="select"
                    placeholder="Select the head of the tree"
                    defaultValue={getMainBoards().find(board => +board.value === +boardId)}
                    value={treeHead}
                    options={getMainBoards()}
                    onChange={(ev) => {
                        setTreeHead(ev)
                    }}
                />
            </div>
            {(!treeData.name && !treeData.id) ?
                <div className='flex auto-center' style={{ height: '100%' }}>
                    <AttentionBox
                        className='attention-box'
                        title='No head node selected'
                        text='To display the objectives tree, you need to select a head node. The head node serves as the starting point for the tree and represents the main objective.'
                    />
                </div>
                : <Tree
                    data={treeData}
                    pathFunc={'diagonal'}
                    orientation='vertical'
                    collapsible={false}
                    nodeSize={{ x: 190, y: 200 }}
                    translate={treeHeadPos}
                    centeringTransitionDuration={200}
                    renderCustomNodeElement={(props) => <NodeElement {...props}
                        foreignObjectProps={{
                            width: 170, height: 180, x: -85, y: -50
                        }} />}

                    pathClassFunc={() => 'custom-link'}
                />}
        </div>
    </>
}